import { icons } from "assets/icons";
import { Horizontal } from "gls/lib";
import React from "react";
import { style } from "typestyle";
import { useSystemAdministratorsStore, useUserRolePermissionStore } from "contexts/RootStore.context";
import IconButton from "components/Button/IconButton";
import { colours } from "styling/colours";
import { SystemAdminUserDto } from "../SystemAdminUserDto";

type RowActionProps = {
  admin: SystemAdminUserDto
}
const RowAction = ({ admin }: RowActionProps) => {

  const { setCurrentAdmin, setEditingMode, setDeleteModalShow } = useSystemAdministratorsStore();
  const { canManageSystemAdministrators } = useUserRolePermissionStore();
  return (

    <Horizontal
      spacing={18}
      verticalAlign="center"
      horizontalAlign="right"
      className={paddingStyle}
    >
      <>
        <IconButton
          ariaLabel={canManageSystemAdministrators ? `edit row` : `view row`}
          icon={
            canManageSystemAdministrators ? (
              <icons.EditIconOutlined
                aria-label="Edit Row"
                width={18}
                height={18}
                fill={colours.secondary}
                id='edit-system-admin'
              />
            ) : (
              <icons.OpenEyeIcon
                aria-label="View Row"
                width={18}
                height={18}
                fill={colours.secondary}
                id='view-system-admin'
              />
            )
          }
          onClick={() => {
            setCurrentAdmin(admin);
            setEditingMode(true)
          }}
        />
        {canManageSystemAdministrators && (
          <IconButton
            ariaLabel="Delete Row"
            icon={<icons.RemoveIcon aria-label="Delete Row" width={18} height={18} />}
            onClick={() => {
              setCurrentAdmin(admin);
              setDeleteModalShow(true)
            }}
            id='delete-system-admin'
          />
        )}
      </>
    </Horizontal>
  );
};
export default RowAction;

const paddingStyle = style({
  padding: "20px 0",
});
